import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'sistema/equipamentos',
		component: Base,
		children: [
			{
				path: '',
				name: 'EquipamentosList',
				component: List,
				meta: {
					path: '/sistema/equipamentos',
					pai: 'Sistema',
					title: 'siS - Equipamentos',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Equipamentos',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'EquipamentosNovo',
				component: Form,
				meta: {
					path: '/sistema/equipamentos',
					pai: 'Sistema',
					title: 'siS - Equipamentos - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Equipamentos',
						class: '',
						active: false,
						url: '/sistema/equipamentos'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'EquipamentosEditar',
				component: Form,
				meta: {
					path: '/sistema/equipamentos',
					pai: 'Sistema',
					title: 'siS - Equipamentos - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Equipamentos',
						class: '',
						active: false,
						url: '/sistema/equipamentos'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]